<template>
  <div class="right-box">
    <replyPage :is-show="replyShow" ref="refReply" @eventBack="back"></replyPage>
    <monacPage :is-show="monacShow" ></monacPage>
  </div>
</template>

<script>
import replyPage from "@/components/views/replyPage";
import monacPage from "@/components/views/monacPage";
import bus from "@/utils/eventBus";

export default {
  name: "rightBox",
  data(){
    return{
      replyShow: false
    }
  },
  computed:{
    monacShow: function (){
      return !this.replyShow;
    }
  },
  mounted() {
    //打开解题内容事件
    bus.on("openTopicInfo",(topicInfo)=>{
      this.replyShow = true;
      this.$refs.refReply.init(topicInfo);
    });
  },
  methods:{
    back: function (){
      this.replyShow = false;
    },
  },
  components:{
    replyPage,
    monacPage
  }
}
</script>

<style scoped>
.right-box{
  margin-left: 35%;
  height: 100vh;
  background-color: #2c3e50;
}
</style>
